<template>
  <div :class="bemBlock">
    <TheProductDetailsSizeSelector
      :product="product"
      :keep-enabled="true"
      :multiple-selection="true"
      prefix="modal"
      @size:change="(size, selSizes) => (selectedSizes = selSizes)"
    />
    <button
      :class="[bemElement('continue'), 'btn', 'btn--primary']"
      @click="$emit('size:confirm', selectedSizes)"
    >
      {{ $msg('label.save.continue', 'forms') }}
    </button>
  </div>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';
import TheProductDetailsSizeSelector from './TheProductDetailsSizeSelector.vue';

export default {
  name: 'TheInStoreStockModalSizeSelector',

  components: {
    TheProductDetailsSizeSelector,
  },

  mixins: [bemClassesMixin],

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    selectedSizes: [],
  }),
};
</script>
